import React from 'react';

import Divider from 'material-ui/Divider';
import DeleteDialog from './DeleteDialog';
import { Link } from 'react-router';
import MenuItem from 'material-ui/MenuItem';

const buildContextMenu = (actions, auth, data) => {
    if (!actions || actions.length === 0) { return []; } // guard

    const NavItems = [];

    const checkConditions = ({show = true, roles, fields}) => {
        let pass = show;

        if (pass && roles !== undefined) {
            pass = roles.some((ROLE) => auth.hasRole(ROLE));
        }

        if (pass && fields !== undefined) {
            if (data === undefined) {
                pass = false;
            } else {
                for (const field of Object.keys(fields)) {
                    if (!data.hasOwnProperty(field) || data[field] === undefined) {
                        pass = false;
                    } else if (Array.isArray(fields[field])) {
                        pass = fields[field].some(function(value) { return value === data[field]; });
                    } else {
                        pass = (fields[field] === data[field] );
                    }
                    if (!pass) { break; }
                }
            }
        }
        return pass;
    };

    let dividerLast = true; // should not start with divider

    actions.forEach((item, index) => {

        const key = index.toString();
        let element = false;

        if (item.type === 'divider') {
            if (!dividerLast) {
                NavItems.push(<Divider key={key}/>);
                dividerLast = true;
            }
        } else if (!item.condition || checkConditions(item.condition)) {
            let props;
            switch (item.type) {
                case 'deleteDialog':
                    props = {
                        key: key,
                        value: item.value,
                        onDelete: item.deleteAction,
                        type: item.dialogType || 'menu',
                        title: item.title || item.label,
                        message: item.message || <span>Are you sure?</span>
                    };
                    if (item.menuTitle !== undefined) { props.menuTitle = item.menuTitle; }
                    element = <DeleteDialog {...props} />;
                    break;

                case 'custom':
                    if (item.element !== undefined) { element = item.element; }
                    break;

                default:
                    props = {primaryText: item.label, key, leftIcon: item.icon};
                    if (item.link !== undefined) {
                        const linkProps = {to: item.link};
                        if (!!item.target) {
                            linkProps.target = item.target;
                        }
                        props.containerElement = <Link key={key} {...linkProps} />;
                    } else if (item.action !== undefined) {
                        props.onTouchTap = item.action;
                    } else {
                        break;
                    }
                    element = (<MenuItem key={key} {...props} />);
                    break;
            }

            if (element) {
                NavItems.push(element);
                dividerLast = false;
            }
        }
    });
    if (dividerLast) {
        NavItems.pop();
    }
    return NavItems;
};

export default buildContextMenu;
